export const defaultConfig = {
    shouldIncludeAdminModule: false,
    apiBaseUrl: process.env.REACT_APP_API_BASE_URL,
    appBaseUrl: process.env.REACT_APP_BASE_URL,
    webSocketUrl: process.env.REACT_WEBSOCKET_URL,
    orgId: process.env.REACT_APP_ORG_ID,
    shouldHaveAddScheduleBtn: true,
    // VA-27781: the token lives in a cookie that expires with it, so a dead token
    // stops existing instead of lingering in localStorage looking valid. getToken()
    // resolves `cookie.<key>`; the `|| localStorage.getItem('access')` fallbacks
    // around the app remain as the migration path for sessions predating this.
    tokenKey: 'cookie.access',
    isNurture: false,
    accessed_from: '',
    isSuperAdmin: false,
    teamCount: 0,
    parentAppName: '',
    nurtureModalCallback: () => {
        return null;
    },
    subscriptionConfig: {
        appIdentifier: process.env.NEXT_PUBLIC_IAM_APP_IDENTIFIER,
        customerSecretKey: process.env.NEXT_PUBLIC_IAM_SECRET_KEY,
        appId: process.env.NEXT_PUBLIC_IAM_APP_ID,
        permissionApiUrl: process.env.NEXT_PUBLIC_IAM_ROUTE
            ? `${process.env.NEXT_PUBLIC_IAM_ROUTE}/permission-matrix`
            : undefined,
    },
};
